import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { useEffect, useState } from "react";
import { Search } from "../../shared/Search";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, ISalesAllocationFilter } from "./Filter";
import { Fetch } from "../../shared/Fetch";
import { ReqDetails } from "./ReqDetails";

export interface ISalesAllocation {
    req_ID?: number,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    req_Category_ID?: number,
    req_Category_Name?: string,
    sales_Manager_ID?: number,
    sales_Manager?: string,
    company?: string,
    branch?: string,
    converted?: boolean,
    company_ID?: number,
    branch_ID?: number,
    createdOn?: Date,
}

interface IProps {
    toast: any,
}

export interface IModel2 {
    open: boolean,
    singleData: any
}

export const Table = (props: IProps) => {

    const [filters, setFilters] = useState<ISalesAllocationFilter>(EmptyFilter);
    const [search, setSearch] = useState<string | null>(null);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISalesAllocation>, loading: boolean });
    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        let filter: any = filters;
        filter.vendor_Company = filter.vendor_Company?.vendor_Company_ID;
        const response = await Fetch("NonPerformingPVAllocation", "GET", null, `filter=${JSON.stringify(filter)}&search=${search}`, props.toast);
        if (response) {
            const data: Array<ISalesAllocation> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Non Performing PV Allocation</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                {/* <Search setSearch={setGlobalFilter} /> */}
            </span>
        </div>
    );

    const converted_Type = (rowData: ISalesAllocation) => {
        return (
            <span className="" >{rowData.converted ? "Yes" : "No"}</span>
        );
    };

    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    useEffect(() => {
        loadTableData();
    }, [filters]);
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: ISalesAllocationFilter) => setFilters(filters)} loading={loading} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                header={header}
                showGridlines
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1}/>
                <Column field="vendor_Company_Name" header="Vendor Company Name" />
                <Column field="sales_Manager" header="Sales Manager" />
                <Column field="company" header="Company" />
                <Column field="branch" header="Branch" />
                <Column field="converted" header="Converted" body={converted_Type} />
                <Column field="createdOn" header="Date" body={(rowData)=><p>{rowData.createdOn.split("T")[0].split("-")[2]}/{rowData.createdOn.split("T")[0].split("-")[1]}/{rowData.createdOn.split("T")[0].split("-")[0]}</p>} />
            </DataTable>
        </>
    )
}